var _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconApp = function SvgIconApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2179 89.1953C59.2179 77.0602 69.4124 62.3411 75.6416 54.4802C76.0923 53.9115 75.688 53.0752 74.9624 53.0752C46.8166 53.0752 24 75.8918 24 104.038C24 132.183 46.8166 155 74.9624 155H76.8499V117.633C76.8499 114.498 74.8949 111.734 71.9817 110.576C65.2533 107.9 59.2179 101.534 59.2179 89.1953Z",
    fill: "#4755EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7602 4.00019C83.7178 4.00019 82.8727 4.84522 82.8727 5.88769V33.0929C82.8727 44.1476 85.8957 54.9949 91.6441 64.4375C96.2458 71.9964 100.505 81.162 100.505 89.1952C100.505 101.902 94.2595 108.273 87.6445 110.803C84.7399 111.915 82.8726 114.766 82.8726 117.876V155H84.7601C112.906 155 135.722 132.183 135.722 104.037V54.9624C135.722 26.8166 112.906 4 84.7601 4L84.7602 4.00019Z",
    fill: "url(#paint0_linear_1560_174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_174",
    x1: 62.2245,
    y1: 143.079,
    x2: 131.499,
    y2: 23.0913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3643D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3528B6"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-app.41b6a87e.svg";
export { ForwardRef as ReactComponent };